import { forwardRef, Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ProfileModule } from '../profile/profile.module';
import { LinkTypesEntity } from './link-types.entity';
import { YoutubeController } from './youtube.controller';
import { YoutubeEntity } from './youtube.entity';
import { YoutubeService } from './youtube.service';
@Module({
  imports: [
    TypeOrmModule.forFeature([YoutubeEntity,LinkTypesEntity]),
    forwardRef(() =>ProfileModule)
],
  controllers: [YoutubeController],
  providers: [YoutubeService],
  exports:[YoutubeService],
})
export class YoutubeModule {}
